import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiOrderPreview, ApiPurchaseAttempt } from './api-purchase-attempt.model';

import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiPurchaseAttemptService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public purchaseAttempt(storeId: string, orderId: string, languageId: string): Observable<ApiPurchaseAttempt> {
        const slug = `order/store/${storeId}/order/${orderId}/purchase-attempt`;
        const url = this.requestService.requestUrl(slug, languageId, null, true, '3');
        return this.http.get<ApiPurchaseAttempt>(url, { withCredentials: true });
    }

    public orderPreview(storeId: string, languageId: string): Observable<ApiOrderPreview> {
        const slug = `wallet/store/${storeId}/order-preview`;
        const url = this.requestService.requestUrl(slug, languageId, null, true, '2', 'itxrest', null);
        return this.http.get<ApiOrderPreview>(url, { withCredentials: true });
    }

    public buyNowOrderPreview(storeId: string, languageId: string, cartId: number): Observable<ApiOrderPreview> {
        const customParams = [{ key: 'orderId', value: cartId.toString() }];
        const slug = `wallet/store/${storeId}/order-preview`;
        const url = this.requestService.requestUrl(slug, languageId, customParams);
        return this.http.get<ApiOrderPreview>(url, { withCredentials: true });
    }
}
